export function adjustTextareaHeight(
  textarea: HTMLTextAreaElement,
  minRows = 1,
  maxRows = 12,
): void {
  const style = window.getComputedStyle(textarea);
  const lineHeight = Number.parseFloat(style.lineHeight);
  const resolvedLineHeight = Number.isFinite(lineHeight) && lineHeight > 0 ? lineHeight : 20;
  const paddingTop = Number.parseFloat(style.paddingTop) || 0;
  const paddingBottom = Number.parseFloat(style.paddingBottom) || 0;
  const borderTop = Number.parseFloat(style.borderTopWidth) || 0;
  const borderBottom = Number.parseFloat(style.borderBottomWidth) || 0;

  textarea.style.height = 'auto';

  const minHeight = resolvedLineHeight * minRows + paddingTop + paddingBottom + borderTop + borderBottom;
  const maxHeight = Number.isFinite(maxRows)
    ? resolvedLineHeight * maxRows + paddingTop + paddingBottom + borderTop + borderBottom
    : undefined;
  const scrollHeight = textarea.scrollHeight;
  const nextHeight = maxHeight != null
    ? Math.min(Math.max(scrollHeight, minHeight), maxHeight)
    : Math.max(scrollHeight, minHeight);

  textarea.style.height = `${nextHeight}px`;
  textarea.style.overflowY = maxHeight != null && scrollHeight > maxHeight ? 'auto' : 'hidden';
}
